import { render, staticRenderFns } from "./StatusBar.vue?vue&type=template&id=2b3100e2&scoped=true&"
var script = {}
import style0 from "./StatusBar.vue?vue&type=style&index=0&id=2b3100e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3100e2",
  null
  
)

export default component.exports